const JAKARTA_TZ = 'Asia/Jakarta';
const MONTHS_ID = ['JAN', 'FEB', 'MAR', 'APR', 'MEI', 'JUN', 'JUL', 'AGU', 'SEP', 'OKT', 'NOV', 'DES'];

function toDate(value: string | Date): Date {
  return value instanceof Date ? value : new Date(value);
}

function jakartaDateParts(date: Date): { year: number; month: number; day: number } {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: JAKARTA_TZ,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).formatToParts(date);
  const year = Number(parts.find((part) => part.type === 'year')?.value);
  const month = Number(parts.find((part) => part.type === 'month')?.value);
  const day = Number(parts.find((part) => part.type === 'day')?.value);
  return { year, month, day };
}

function startOfJakartaDay(date: Date): number {
  const { year, month, day } = jakartaDateParts(date);
  return Date.UTC(year, month - 1, day);
}

export function formatRelativeNotificationTime(createdAt: string | Date, now: Date = new Date()): string {
  const created = toDate(createdAt);
  const diffMs = now.getTime() - created.getTime();
  const minutes = Math.max(0, Math.floor(diffMs / 60000));
  if (minutes < 60) {
    return `${minutes}m`;
  }
  return `${Math.floor(minutes / 60)}j`;
}

export function notificationDateGroup(createdAt: string | Date, now: Date = new Date()): string {
  const created = toDate(createdAt);
  const today = startOfJakartaDay(now);
  const target = startOfJakartaDay(created);
  const dayDiff = Math.round((today - target) / 86400000);
  if (dayDiff <= 0) {
    return 'HARI INI';
  }
  if (dayDiff === 1) {
    return 'KEMARIN';
  }
  const { month, day } = jakartaDateParts(created);
  return `${day} ${MONTHS_ID[month - 1]}`;
}
